// Generated by scripts/build-pet-evolution-clips.mjs — do not edit.
export const petEvolutionClipUrls: Record<string, string> = {
  "otter": "/assets/pet-evolution/v2/clips/otter.19335fca37.json",
  "rabbit": "/assets/pet-evolution/v2/clips/rabbit.8a2db9339d.json",
  "penguin": "/assets/pet-evolution/v2/clips/penguin.48e742a112.json",
  "fox": "/assets/pet-evolution/v2/clips/fox.0e98a4ac39.json",
  "corgi": "/assets/pet-evolution/v2/clips/corgi.62ebd531e0.json",
  "cat": "/assets/pet-evolution/v2/clips/cat.9346dac608.json",
  "red-panda": "/assets/pet-evolution/v2/clips/red-panda.d6b61035a1.json",
  "panda": "/assets/pet-evolution/v2/clips/panda.bd79e52bd7.json",
  "capybara": "/assets/pet-evolution/v2/clips/capybara.e812e1543b.json",
  "owl": "/assets/pet-evolution/v2/clips/owl.8910c6a87d.json",
  "squirrel": "/assets/pet-evolution/v2/clips/squirrel.6eb83597c9.json",
  "parrot": "/assets/pet-evolution/v2/clips/parrot.f8e009fa28.json",
  "toucan": "/assets/pet-evolution/v2/clips/toucan.724474ea8e.json",
  "flamingo": "/assets/pet-evolution/v2/clips/flamingo.650d86b323.json",
  "bee": "/assets/pet-evolution/v2/clips/bee.b303668c37.json",
  "butterfly": "/assets/pet-evolution/v2/clips/butterfly.d018abee1c.json",
  "seal": "/assets/pet-evolution/v2/clips/seal.d54dc369c7.json",
  "pufferfish": "/assets/pet-evolution/v2/clips/pufferfish.5c6d12c2e0.json",
  "axolotl": "/assets/pet-evolution/v2/clips/axolotl.28fa89c5be.json",
  "octopus": "/assets/pet-evolution/v2/clips/octopus.8e0434fd78.json",
  "dolphin": "/assets/pet-evolution/v2/clips/dolphin.f837a65dd5.json",
  "sea-turtle": "/assets/pet-evolution/v2/clips/sea-turtle.4a766de7e2.json",
  "whale": "/assets/pet-evolution/v2/clips/whale.e6d38b257e.json",
  "jellyfish": "/assets/pet-evolution/v2/clips/jellyfish.4bbc34f1c4.json",
  "seahorse": "/assets/pet-evolution/v2/clips/seahorse.2b296049bd.json",
  "clownfish": "/assets/pet-evolution/v2/clips/clownfish.003fea9bff.json",
  "crab": "/assets/pet-evolution/v2/clips/crab.48c6a9b763.json",
  "eagle": "/assets/pet-evolution/v2/clips/eagle.ceb984c606.json",
  "hummingbird": "/assets/pet-evolution/v2/clips/hummingbird.da7f48f385.json",
  "dragonfly": "/assets/pet-evolution/v2/clips/dragonfly.0483a4f6e1.json",
  "ladybug": "/assets/pet-evolution/v2/clips/ladybug.e3b8f12cf5.json",
  "swan": "/assets/pet-evolution/v2/clips/swan.148fa35f61.json",
  "peacock": "/assets/pet-evolution/v2/clips/peacock.18d7c04db7.json",
  "tiger": "/assets/pet-evolution/v2/clips/tiger.c5581037b8.json",
  "lion": "/assets/pet-evolution/v2/clips/lion.e14b57846e.json",
  "elephant": "/assets/pet-evolution/v2/clips/elephant.6c752ec463.json",
  "giraffe": "/assets/pet-evolution/v2/clips/giraffe.05b19e2194.json",
  "deer": "/assets/pet-evolution/v2/clips/deer.59106d15ec.json",
  "koala": "/assets/pet-evolution/v2/clips/koala.c88dc65cca.json",
  "hedgehog": "/assets/pet-evolution/v2/clips/hedgehog.ac3324de51.json"
};
